<footer class="justify-content-center bg-light footer py-4">
	<div class="text-muted text-center">
		&copy;{{ currentYear }} PointHealth. All rights reserved.
	</div>
</footer>
